export default __webpack_public_path__ + "static/media/ipad-pencil.70b12185.png";